/**
 * Filter utilities — debounce and select population.
 */

import { escapeHtml } from "../utils/escapeHtml";

/**
 * Generic debounce: delays invocation of `fn` until `delayMs` ms
 * have elapsed since the last call.
 */
export function debounce<T extends (...args: any[]) => any>(
  fn: T,
  delayMs: number,
): (...args: Parameters<T>) => void {
  let timer: ReturnType<typeof setTimeout> | null = null;
  return (...args: Parameters<T>) => {
    if (timer !== null) clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delayMs);
  };
}

/**
 * Populate a <select> element with <option> values.
 * Adds a leading placeholder option with an empty value.
 */
export function populateSelect(
  select: HTMLSelectElement | HTMLElement | null,
  values: string[],
  placeholder: string,
): void {
  if (!select) return;
  select.innerHTML =
    `<option value="">${escapeHtml(placeholder)}</option>` +
    values
      .map(
        (value) =>
          `<option value="${escapeHtml(value)}">${escapeHtml(value)}</option>`,
      )
      .join("");
}
